<template>
  <div id="comment" class="section comments columns is-gapless is-mobile is-centered">
    <div class="section--main--holder column is-12-mobile is-10-desktop">
      <section class="section--main">
        <h2 class="section--title centered">
          <img src="/static/img/titles/Comment.png" alt="Comments">
          <strong class="seo">Comments</strong>
        </h2>

        <ul v-if="commentsData" class="comment--list main_cast">
          <li v-for="comment in commentsData" v-bind:key="comment.id" class="comment--item">
            <article class="comment">
              <h3 class="comment--title" v-html="comment.title.rendered"></h3>
              <p class="comment--main" v-html="comment.acf.comment_content"></p>
            </article>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios.js'

export default {
  name: 'comments',
  data () {
    return {
      commentsData: null
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      axios.get('wp-json/wp/v2/comments?filter[posts_per_page]=100')
        .then(response => {
          this.commentsData = response.data
        })
        .catch(e => { console.log(e) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Comments.vue